import { OneCRequestStatus } from '@insurance/api/requests'
import { Tag, TagProps } from 'antd'
import { useTranslation } from 'react-i18next'

type Props = {
  status?: OneCRequestStatus
}

const statusColors: Record<OneCRequestStatus, TagProps['color']> = {
  [OneCRequestStatus.SUCCESS]: 'green',
  [OneCRequestStatus.ERROR]: 'red',
  [OneCRequestStatus.NETWORK_ERROR]: 'volcano'
}

export const RequestLogsStatusTag = ({ status }: Props) => {
  const { t } = useTranslation()

  if (!status) return null

  return <Tag color={statusColors[status]}>{t(status)}</Tag>
}
